import ct from "class-types.macro";
import React from "react";
const OutletShopPopularProductsHeader = () => {
  return <h2 className={ct("font-semibold", "text-2xl", "mb-0", "mt-8", "pb-32", "text-center", "md:text-3xl", "md:mt-24")} data-sentry-component="OutletShopPopularProductsHeader" data-sentry-source-file="OutletShopPopularProductsHeader.tsx">
      Shop Popular Outlet Products
    </h2>;
};
export default OutletShopPopularProductsHeader;